import { FONT } from "../../../value/staticValues";
import { numberOfCommas, parseLocaleDatetime, zeroFill } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";


import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import PurchaseAdd from "./PurchaseAdd";

export interface LicenseData {
    license_id: string;
    license_name: string;
    license_number: string;
}

export interface ProductData {
    product_id: string;
    product_name: string;
    product_description: string;
    product_type_code: string;
}

export interface ProductOptionData {
    product_option_id: string;
    product_option_name: string;
    product_option_description: string;
    product_option_type_code: string;
    product_option_target_code: string;
}

export interface PurchaseDetail {
    purchase_detail_id: string;
    purchase_target_code: string;
    product_type_code: string;
    product_name: string;
    product_count: string;
    payment_amount: number;
    create_ts: string;
    update_ts: string;

    product: ProductData;
    product_option: ProductOptionData;
}

export interface PurchaseData {
    purchase_id: string;
    purchase_number: string;
    license_name: string;
    email: string;
    purchase_ts: string;
    payment_method_code: string;
    total_payment_amount: number;
    receipt_link_url: string;
    license: LicenseData;
    purchase_details: PurchaseDetail[];
    purchase_source: string;
    create_ts: string;
    update_ts: string;
}

export const initPurchaseData = {
    purchase_id: "",
    purchase_number: "",
    purchase_ts: "",
    license_name: "",
    email: "",
    payment_method_code: "",
    total_payment_amount: 0,
    receipt_link_url: "",
    license: {
        license_id: "",
        license_name: "",
        license_number: ""
    },
    purchase_details: [],
    purchase_source: "",
    create_ts: "",
    update_ts: ""
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SERVICE_PURCHASE_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "PURCHASE_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "PURCHASE_DELETE",
        },
    }
]



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_PURCHASE_NUMBER_TEXT"),
        accessor: "purchase_number",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? zeroFill(value, 8) : ""}</div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_SOURCE_TEXT"),
        accessor: "purchase_source",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? value : "FornaX Cloud Official Site"}</div>)
    },
    {
        Header: i18n.t("ACCOUNT_TEXT"),
        accessor: "email",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_PAYMENT_METHOD_TEXT"),
        accessor: "payment_method_code",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "CRDCARD" ? "#66abe8" : value === "DPST" ? "#92ca6e" : value == "CPN" ? "#ae4f5a" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "CRDCARD" ? "신용카드"
                    : value === "DPST" ? "이체"
                    : value === "CPN" ? "쿠폰"
                    : ""
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_LICENSE_NUMBER_TEXT"),
        accessor: "license",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>
            {
                value ? value.license_number : ""
            }
        </div>)
    },
    {
        Header: i18n.t("SERVICE_LICENSE_NAME_TEXT"),
        accessor: "license_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>
            {
                value
            }
        </div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_PAYMENT_TOTAL_AMOUNT"),
        accessor: "total_payment_amount",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.greenText}}>
            {
                value > 0 ? numberOfCommas(value) + " 원" : "0 원"
            }
        </div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_DATE_TEXT"),
        accessor: "purchase_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
]


export const purchaseAddModalContent = {
    title: i18n.t("SERVICE_PURCHASE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PurchaseAdd />,
}

export const PaymentMethodTypeDropdownItem:DropdownType[] = [
    {
        value: "CRDCARD",
        label: "신용카드"
    },
    {
        value: "DPST",
        label: "이체"
    },
    {
        value: "CPN",
        label: "쿠폰"
    }
]




export const detailTableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_PURCHASE_DETAIL_TARGET_TEXT"),
        accessor: "purchase_target_code",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "LICS" ? "#66abe8" : value === "OPTS" ? "#92ca6e" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "LICS" ? "라이센스"
                    : value === "OPTS" ? "옵션"
                    : ""
                }
            </div>
        )
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_NAME_TEXT"),
        accessor: "product",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.product_name || ""}</div>)
    },
    {
        Header: i18n.t("SERVICE_PRODUCT_OPTION_NAME_TEXT"),
        accessor: "product_option",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.product_option_name || ""}</div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_OPTION_PRICE_TEXT"),
        accessor: "payment_amount",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.greenText}}>
            {
                value > 0 ? numberOfCommas(value) + " 원" : "0 원"
            }
        </div>)
    },
    {
        Header: i18n.t("SERVICE_PURCHASE_OPTION_COUNT_TEXT"),
        accessor: "product_count",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>
            {
                value
            }
        </div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
]




const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}